// Publicación directa en Meta y bandeja social: aparcadas mientras se usa Metricool (no se borra nada).
export const META_DIRECT_ENABLED = false;
